// An armed routine cleanup confirms only the threads that were on screen when it was armed. A sweep
// can fold more routine mail into a carried group (same id), so the armed state remembers which
// list it was armed on and is dropped when that list changes; the server refuses an approval sent
// with an older `itemsRev` as well.
import type { RoutineGroupView } from "@shared/api";

/** What the arming is bound to: the group's items revision and its exact threads. */
export function routineArmKey(group: Pick<RoutineGroupView, "itemsRev" | "items">): string {
  return [group.itemsRev, group.items.length, ...group.items.map((i) => i.threadKey)].join("\n");
}

/** Whether an arming made on `armedKey` still holds for the group as it is now. */
export function routineArmHolds(
  armedKey: string | null,
  group: Pick<RoutineGroupView, "itemsRev" | "items">,
): boolean {
  return armedKey !== null && armedKey === routineArmKey(group);
}
